/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { BettingFoldGrouped, BettingRecordTrack } from '@store/bettingHistoryStore'
import { BettingHistoryLeagueWrap } from './index.style'

import { BettingHistoryListItemFold } from './BettingHistoryListItemFold'
import { BETTING_HISTORY_TAB_KEY } from '@constants/index'
import { PAGE_TYPE } from '@interface/common'
import { observer } from 'mobx-react'
import { BET_CANCEL_TYPE } from 'adv-protocol/src/GameCommon'
import { FROM_VIEW_TYPE } from '@v2/constants/common'

interface BettingHistoryListItemTournamentProps {
  track: BettingRecordTrack
  fold: BettingFoldGrouped
  betCanceled: boolean
  betCancelType: BET_CANCEL_TYPE
  bettorBetId: string
  clubId: string
  isShareHistory: boolean // 공유베팅 유무
  fetchItems?: (resetForce: boolean, clubId: string) => Promise<void>
  currentTabKey?: BETTING_HISTORY_TAB_KEY
  pageType?: PAGE_TYPE
  fromViewType?: FROM_VIEW_TYPE
}

export const BettingHistoryListItemTournament: React.FC<BettingHistoryListItemTournamentProps> = observer((
  props: BettingHistoryListItemTournamentProps,
) => {

  const {
    track,
    fold,
    betCanceled,
    bettorBetId,
    clubId,
    isShareHistory,
    fetchItems,
    pageType,
    betCancelType,
    currentTabKey,
    fromViewType,
  } = props

  const eleFolds = []
  let count = 1
  for (const el of fold.data) {
    const historyItemKey = `BettingHistoryListItemTournament:BettingHistoryListItemFold:${count}`
    const isFirstFold = count === 1

    eleFolds.push(
      <BettingHistoryListItemFold
        key={historyItemKey}
        currentTabKey={currentTabKey}
        track={track}
        fold={fold}
        foldData={el}
        betCanceled={betCanceled}
        betCancelType={betCancelType}
        bettorBetId={bettorBetId}
        clubId={clubId}
        isShareHistory={isShareHistory}
        fetchItems={fetchItems}
        pageType={pageType}
        fromViewType={fromViewType}
        isFirstFold={isFirstFold}
      />,
    )
    count += 1
  }

  // let eleVS
  // if (isNumber(homeScore) && isNumber(awayScore)) {
  //   const homeCss = homeScore > awayScore ? Win : undefined
  //   const awayCss = awayScore > homeScore ? Win : undefined
  //   if (homeScore)
  //     eleVS = (
  //       <span>
  //         <ResultNum css={homeCss}>{homeScore}</ResultNum>:<ResultNum css={awayCss}>{awayScore}</ResultNum>
  //       </span>
  //     )
  // } else {
  //   eleVS = <span>VS</span>
  // }

  return (
    // 디자인 시안상 <BettingHistoryLeagueWrap> 마지막 요소에는 border-bottom: none이 되어야됩니다.
    // 만약 경기가 하나뿐이라면 선이 보이지 않아야합니다.
    // css에서 last-of-type / last-child로 제어하려 했으나 모두 적용되질 않아서 개발쪽에서 처리부탁드립니다.
    <BettingHistoryLeagueWrap className="betting-history-league-wrap">
      {/*{`${sportName} - ${tournamentName}`}*/}

      {/*<span>*/}
      {/*  <span css={TxtLimit}>{homeTeamName}</span>*/}
      {/*  /!* 경기가 끝난 경우 vs가 아닌 점수가 나와야하는데 나오질 않습니다 확인부탁드립니다. *!/*/}
      {/*  {eleVS}*/}
      {/*  <span css={TxtLimit}>{awayTeamName}</span>*/}
      {/*</span>*/}

      {eleFolds}
    </BettingHistoryLeagueWrap>
  )
})
